<template>
  <div style="flex-grow: 1">
    <v-dialog v-model="alterDialog" max-width="300px">
      <div class="text-center">
        <v-sheet
          class="px-7 pt-7 pb-4 mx-auto text-center d-inline-block"
          color="blue-grey darken-3"
          dark
        >
          <div class="grey--text text--lighten-1 text-body-2 mb-4">
            {{ $t('Os dados informados não serão salvos, deseja continuar?') }}
          </div>

          <v-btn
            :disabled="loading"
            class="ma-1"
            color="grey"
            text
            @click="alterDialog = false"
          >
            {{ $t('Não') }}
          </v-btn>

          <v-btn
            :loading="loading"
            class="ma-1"
            color="#B14949"
            text
            @click="closeDialog"
          >
            {{ $t('Sim') }}
          </v-btn>
        </v-sheet>
      </div>
    </v-dialog>

    <v-card class="card-pad d-flex align-center mb-4" height="75">
      <v-btn depressed small text color="grey" @click="close">
        <v-icon x-small>mdi-arrow-left-bold</v-icon>
        {{ $t('Voltar') }}
      </v-btn>
    </v-card>

    <v-window v-model="step" touchless>
      <v-window-item :value="0">
        <v-form
          class="form"
          ref="firstForm"
          v-model="firstValid"
          lazy-validation
        >
          <v-card class="card-pad pa-0 pb-2 mb-4">
            <v-row class="ma-0 px-4" dense justify="end">
              <v-col class="d-flex align-center my-2">
                <strong>
                  {{ `${title} Checklist Template` }}
                </strong>
              </v-col>
            </v-row>
            <v-divider />
            <v-row class="ma-0 px-3 mt-2" dense>
              <v-col class="pb-0" cols="12" lg="6">
                <label class="label">{{ $t('Nome do template') }}</label>
                <v-text-field
                  hide-details="auto"
                  v-model="currentChecklistTemplate.name"
                  :rules="nameRules"
                  outlined
                  class="primary-input"
                ></v-text-field>
              </v-col>
              <v-col class="pb-0" cols="12" lg="6">
                <label class="label">Tipo do template</label>
                <v-select
                  hide-details="auto"
                  v-model="currentChecklistTemplate.type"
                  :rules="[(v) => v != null || 'Campo obrigatório']"
                  :items="[
                    {
                      text: 'Equipamento',
                      value: 0,
                    },
                    {
                      text: 'Setor',
                      value: 1,
                    },
                  ]"
                  outlined
                  class="primary-input"
                  item-text="text"
                  item-value="value"
                  append-icon="mdi-chevron-down"
                ></v-select>
              </v-col>
              <v-col cols="12" v-if="currentChecklistTemplate.type == 0">
                <label class="label">{{ $t('Equipamentos padrão') }}</label>
                <v-autocomplete
                  hide-details="auto"
                  v-model="standardEquipmentSelected"
                  :items="standardEquipments"
                  item-text="name"
                  multiple
                  deletable-chips
                  return-object
                  outlined
                  class="primary-input"
                  :search-input.sync="search"
                  @blur="search = ''"
                >
                  <template
                    v-slot:selection="{ attrs, item, select, selected }"
                  >
                    <v-chip
                      v-bind="attrs"
                      :input-value="selected"
                      close
                      color="#BBCF20"
                      text-color="#fff"
                      small
                      @click="select"
                      @click:close="remove(item)"
                    >
                      {{ item.name }}
                    </v-chip>
                  </template>
                </v-autocomplete>
              </v-col>
              <v-col cols="12" v-if="currentChecklistTemplate.type == 1">
                <label class="label">{{ $t('Setores') }}</label>
                <v-autocomplete
                  hide-details="auto"
                  v-model="selectedDepartments"
                  :items="departments"
                  item-text="name"
                  multiple
                  deletable-chips
                  return-object
                  outlined
                  item-value="id"
                  itemid="id"
                  class="primary-input"
                  append-icon="mdi-chevron-down"
                  :search-input.sync="search"
                  @blur="search = ''"
                >
                  <template v-slot:item="{ item }">
                    <span class="text-caption" v-if="item.unidade">
                      {{ item.name }} / {{ item.unidade.name }}
                    </span>
                    <span class="text-caption" v-else>
                      {{ item.name }}
                    </span>
                  </template>
                  <template
                    v-slot:selection="{ attrs, item, select, selected }"
                  >
                    <v-chip
                      v-bind="attrs"
                      :input-value="selected"
                      close
                      color="#BBCF20"
                      text-color="#fff"
                      small
                      @click="select"
                      @click:close="removeDepartment(item)"
                    >
                      {{ item.unidade ? item.unidade.name : '' }} /
                      {{ item.name }}
                    </v-chip>
                  </template>
                </v-autocomplete>
              </v-col>
            </v-row>
          </v-card>

          <v-card class="card-pad pa-0 pb-2">
            <v-row class="ma-0 px-4" dense justify="end">
              <v-col class="d-flex align-center my-2">
                <strong>{{ $t('Itens de Checklist') }}</strong>
                <v-spacer />
                <v-btn
                  depressed
                  class="mr-2 hidden-sm-and-down primary-button"
                  color="#0F3565"
                  dark
                  @click="selectPatternItems"
                  :loading="patternItemsLoading"
                >
                  {{
                    patternItems
                      ? $t('Desmacar Itens Padrão')
                      : $t('Selecionar Itens Padrão')
                  }}
                </v-btn>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      depressed
                      class="mt-2 mr-1 hidden-md-and-up"
                      small
                      color="#0F3565"
                      dark
                      v-bind="attrs"
                      v-on="on"
                      @click="selectPatternItems"
                      :loading="patternItemsLoading"
                    >
                      <v-icon>
                        {{
                          patternItems
                            ? 'mdi-text-box-remove-outline'
                            : 'mdi-text-box-check-outline'
                        }}
                      </v-icon>
                    </v-btn>
                  </template>
                  <span>
                    {{
                      patternItems
                        ? $t('Desmacar Itens Padrão')
                        : $t('Selecionar Itens Padrão')
                    }}
                  </span>
                </v-tooltip>

                <v-btn
                  depressed
                  class="mr-4 hidden-sm-and-down secondary-button"
                  color="#BBCF20"
                  dark
                  @click="visible = !visible"
                >
                  Filtros
                </v-btn>
                <v-btn
                  depressed
                  class="mt-2 mr-4 hidden-md-and-up"
                  small
                  color="#BBCF20"
                  dark
                  @click="visible = !visible"
                >
                  <v-icon> mdi-filter </v-icon>
                </v-btn>
              </v-col>
            </v-row>

            <v-divider></v-divider>

            <v-expand-transition>
              <div v-show="visible">
                <v-row class="ma-0 mx-4 mt-2" dense>
                  <v-col cols="12" sm="6" md="6" lg="6">
                    <label class="label">{{ $t('Item checklist') }}</label>
                    <v-text-field
                      hide-details="auto"
                      name="nameItem"
                      v-model="checklistItemName"
                      outlined
                      class="primary-input"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6" md="6" lg="6">
                    <label class="label">{{ $t('Classe') }}</label>
                    <v-autocomplete
                      hide-details="auto"
                      class="primary-input"
                      v-model="checklistItemClassId"
                      :items="checklistItemClasses"
                      item-value="id"
                      item-text="name"
                      :loading="classLoading"
                      outlined
                    ></v-autocomplete>
                  </v-col>
                  <v-col class="" cols="12">
                    <div class="d-flex align-center justify-end">
                      <v-btn
                        depressed
                        class="mx-2 secondary-button"
                        color="#BBCF20"
                        @click="filterTable"
                      >
                        <span>Filtrar</span>
                        <v-icon class="pl-2">mdi-magnify</v-icon>
                      </v-btn>

                      <v-btn
                        depressed
                        color="#20202066"
                        class="clear-button"
                        @click="reset"
                      >
                        <span>{{ $t('Limpar') }}</span>
                        <v-icon class="pl-2">mdi-cached</v-icon>
                      </v-btn>
                    </div>
                  </v-col>
                </v-row>
              </div>
            </v-expand-transition>

            <v-data-table
              :loading="checklistItemLoading"
              :loading-text="$t('Carregando...')"
              :no-data-text="$t('Nenhum item de checklist encontrado')"
              :headers="headers"
              :items="checklistItems"
              v-model="checklistItemsSelected"
              :single-select="false"
              item-key="id"
              show-select
              class="main-table mx-2"
              hide-default-footer
              hide-default-header
              :header-props="headerProps"
              :mobile-breakpoint="330"
              :items-per-page="pageSize"
            >
              <template #header="{ props, on }">
                <thead>
                  <tr>
                    <th
                      class="text-center"
                      v-for="header in props.headers"
                      :key="header.value"
                    >
                      <v-simple-checkbox
                        v-if="header.value === 'data-table-select'"
                        v-model="props.everyItem"
                        :indeterminate="props.someItems && !props.everyItem"
                        color="purple"
                        @input="on['toggle-select-all']"
                      ></v-simple-checkbox>

                      <div>
                        <v-hover v-slot="{ hover }">
                          <div>
                            <span>{{ $t(header.text) }}</span>
                            <v-icon
                              v-if="
                                hover &&
                                header.value != 'data-table-select' &&
                                header.value != 'actions'
                              "
                              color="white"
                              class="mx-2"
                              @click="on.sort(header.value)"
                            >
                              {{
                                props.options.sortBy.includes(header.value)
                                  ? `mdi-chevron-down`
                                  : `mdi-chevron-up`
                              }}
                            </v-icon>
                          </div>
                        </v-hover>
                      </div>
                    </th>
                  </tr>
                </thead>
              </template>

              <template #[`item.name`]="{ item }">
                {{ item.name }}
              </template>

              <template #[`item.class`]="{ item }">
                {{ item.checklistItemClass.name }}
              </template>
            </v-data-table>

            <div class="pagination mx-2">
              <div class="item-pagination block-one">
                <v-menu bottom offset-y>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      v-bind="attrs"
                      v-on="on"
                      class="btn"
                      depressed
                      color="#C0C0C0"
                      small
                    >
                      qtd: {{ pageSize }}
                    </v-btn>
                  </template>
                  <v-list>
                    <v-list-item
                      v-for="(size, i) in sizes"
                      :key="i"
                      @click="pageSize = size"
                    >
                      <v-list-item-title>{{ size }}</v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>
              </div>

              <div class="item-pagination block-two">
                <v-pagination
                  class="pagination-item"
                  v-model="page"
                  :length="totalPages"
                  :total-visible="7"
                  circle
                ></v-pagination>
              </div>
            </div>
          </v-card>
        </v-form>
      </v-window-item>
    </v-window>

    <div class="d-flex mt-4">
      <v-btn
        class="quaternary-button"
        @click="close"
        v-if="step === 0"
        color="#B14949"
      >
        Cancelar
      </v-btn>
      <v-spacer></v-spacer>
      <v-btn
        depressed
        @click="submit"
        class="mr-0 primary-button"
        :loading="loading"
      >
        {{ $t(buttonText) }}
      </v-btn>
    </div>
  </div>
</template>

<style scoped>
.v-application .primary--text {
  color: #707070 !important;
  caret-color: #707070 !important;
}
</style>

<script>
import ApiService from '../../../../../services/ApiService'
import GeneralService from '../../../../../services/GeneralService'

export default {
  props: {
    templateId: String,
  },

  async created() {
    this.institutionId = JSON.parse(localStorage.getItem('institution')).id

    await Promise.all([
      this.getChecklisItemClasses(),
      this.updateTableItems(),
      this.getStandardEquipments(),
      this.getDepartments(),
    ])

    if (this.templateId) {
      this.getTemplate()
    } else {
      this.title = 'Novo'
    }
  },

  data: () => ({
    selectedDepartments: [],
    departments: [],
    unidades: [],
    step: 0,
    title: '',
    errorMessage: '',
    message: '',
    visible: false,
    loading: false,
    checklistItemLoading: false,
    standardEquipmentLoading: false,
    patternItemsLoading: false,
    patternItems: false,
    firstValid: true,
    alterDialog: false,
    changedData: false,
    isEditing: false,
    showSuccess: false,
    error: false,
    institutionId: null,
    checklistItemsSelected: [],
    checklistItems: [],
    checklistItemName: null,
    checklistItemClassId: null,
    search: null,
    checklistItemClasses: [],
    standardEquipmentSelected: [],
    standardEquipments: [],
    currentChecklistTemplate: {
      id: 0,
      name: '',
    },
    page: 1,
    totalPages: 1,
    pageSize: 10,
    sizes: [10, 30, 90, 180],
    filter: {
      page: 1,
      pageSize: 10,
      classId: null,
      name: null,
    },
    headers: [
      {
        text: 'Item Checklist',
        align: 'center',

        value: 'name',
      },
      {
        text: 'Classe',
        align: 'center',

        value: 'class',
      },
    ],
    headerProps: {
      sortByText: 'Ordenar por',
    },
    nameRules: [
      (v) => !!v || 'Nome do template requerido',
      (v) =>
        (v && v.length <= 128) ||
        'Nome do template deve ter no máximo 128 caracteres',
    ],
    apiService: new ApiService(),
    generalService: new GeneralService(),
    departmentLoading: false,
  }),

  computed: {
    buttonText() {
      return this.isEditing ? 'Atualizar' : 'Adicionar'
    },
  },

  methods: {
    async getDepartments() {
      this.departmentLoading = true

      await this.apiService
        .get(`department/listActive/${this.institutionId}`)
        .then((response) => {
          this.departments = response.content
          this.departmentLoading = false
        })
        .catch(() => {
          this.departmentLoading = false
        })
    },

    close() {
      sessionStorage.clear()
      if (this.changedData) {
        this.alterDialog = true
      } else {
        this.$router.go(-1)
      }
    },

    closeDialog() {
      this.changedData = false
      this.close()
    },

    removeDepartment(item) {
      this.selectedDepartments.splice(this.selectedDepartments.indexOf(item), 1)
      this.selectedDepartments = [...this.selectedDepartments]
    },

    remove(item) {
      this.standardEquipmentSelected.splice(
        this.standardEquipmentSelected.indexOf(item),
        1
      )
      this.standardEquipmentSelected = [...this.standardEquipmentSelected]
    },

    async getTemplate() {
      await this.apiService
        .get(`checklistTemplate/${this.templateId}`)
        .then((response) => {
          this.currentChecklistTemplate = response.content
          this.checklistItemsSelected = response.content.templateItems.map(
            (templateItem) => templateItem.checklistItem
          )
          const standardEquipment =
            response.content.templateStandardEquipment.map(
              (templateEquipment) => templateEquipment.standardEquipment
            )

          this.selectedDepartments = response.content.templateDepartment.map(
            (x) => x.department
          )

          standardEquipment.map((equip) => {
            const standard = this.standardEquipments.find(
              (x) => x.standardEquipmentId == equip.id
            )

            if (standard) {
              this.standardEquipmentSelected.push(standard)
            }
          })

          this.title = 'Editar'
          this.isEditing = true
        })
        .catch((err) => {
          this.errorMessage = err.message
          this.error = true

          if (err.status === 409) {
            this.$router.go(-1)
          }

          setTimeout(() => {
            this.error = false
          }, 4000)
        })
    },

    async selectPatternItems() {
      this.patternItemsLoading = true

      if (this.patternItems) {
        this.checklistItemsSelected = this.checklistItemsSelected.filter(
          (x) => !x.isPattern
        )
        this.patternItems = false
      } else {
        await this.apiService
          .get(`checklistItem/list/${this.institutionId}`)
          .then((response) => {
            this.checklistItemsSelected = response.content.filter(
              (x) => x.isPattern
            )
            this.patternItems = true
          })
      }
      this.patternItemsLoading = false
    },

    filterTable() {
      this.filter.classId = this.checklistItemClassId
      this.filter.name = this.checklistItemName
      this.filter.institutionId = this.institutionId
      this.updateTableItems()
    },

    reset() {
      this.filter = {
        page: 1,
        pageSize: 10,
        classId: null,
        name: null,
      }
      this.checklistItemClassId = null
      this.checklistItemName = null

      this.updateTableItems()
    },

    showSuccessAlert(message) {
      this.message = message

      this.showSuccess = true

      setTimeout(() => {
        this.showSuccess = false
        this.closeDialog()
      }, 1000)
    },

    async submit() {
      if (this.$refs.firstForm.validate()) {
        this.loading = true

        let departmentIds = this.selectedDepartments
          ? this.selectedDepartments.map((x) => x.id)
          : []

        const checklistTemplate = {
          Id: this.currentChecklistTemplate.id,
          Name: this.currentChecklistTemplate.name,
          type: this.currentChecklistTemplate.type,
          ChecklistItems: this.checklistItemsSelected,
          StandardEquipments: this.standardEquipmentSelected,
          departmentIds: departmentIds,
          InstitutionId: this.institutionId,
        }

        let url = 'checklistTemplate/add'

        if (this.isEditing) {
          url = 'checklistTemplate/edit'
        }

        await this.apiService
          .post(url, checklistTemplate)
          .then((response) => {
            window.scrollTo(0, 0)
            this.showSuccessAlert(response.message)
            this.changedData = false
          })
          .catch((err) => {
            window.scrollTo(0, 0)
            this.errorMessage = err.message
            this.error = true

            setTimeout(() => {
              this.error = false
            }, 4000)
          })
      } else {
        this.$refs.firstForm.$el.scrollIntoView({ behavior: 'smooth' })
      }
      this.loading = false
    },

    async getChecklisItemClasses() {
      this.classLoading = true

      await this.apiService
        .get(`checklistItemClass/list/${this.institutionId}`)
        .then((resposne) => {
          this.checklistItemClasses = resposne.content
          this.classLoading = false
        })
    },

    async getStandardEquipments() {
      this.standardEquipmentLoading = true

      this.standardEquipments =
        await this.generalService.getStandardEquipmentsByInstitution(
          this.institutionId
        )
      this.standardEquipmentLoading = false
    },

    async updateTableItems() {
      this.filter.templateId = this.templateId

      this.checklistItemLoading = true
      this.filter.institutionId = this.institutionId

      await this.apiService
        .post('checklistItem/list', this.filter)
        .then((response) => {
          this.totalPages = response.content.pager.totalPages
          this.checklistItems = response.content.checklistItems
          this.checklistItemLoading = false
        })
    },
  },

  watch: {
    currentChecklistTemplate: {
      deep: true,
      handler() {
        this.changedData = true
      },
    },
    pageSize() {
      this.filter.pageSize = this.pageSize
      this.filter.page = 1
      this.updateTableItems()
    },

    page() {
      this.filter.page = this.page
      this.updateTableItems()
    },
  },
}
</script>
